var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1658 7.55117V17.153C22.1658 17.87 21.5133 18.4496 20.7061 18.4496H11.9481L6.10947 22.3394V18.4496H3.19013C2.38294 18.4496 1.73047 17.87 1.73047 17.153V5.48357C1.73047 4.76655 2.38294 4.187 3.19013 4.187H18.8401M20.0327 3.06458L22.1387 1.08252L25.5888 4.32961L23.4828 6.31167M20.0327 3.06458L23.4828 6.31167M20.0327 3.06458L18.8401 4.187M23.4828 6.31167L19.0719 10.463L14.8551 11.1846L15.6218 7.2159L18.8401 4.187",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIco);
export default __webpack_public_path__ + "static/media/feedback_ico.6933223fe0fc90b74f01aa053849217c.svg";
export { ForwardRef as ReactComponent };